import moment from "@/utils/moment";

const TICKET_TAGS = [];

export default {
  data() {
    return {
      ticketTags: TICKET_TAGS
    };
  },
  methods: {
    setAdvanceTimeTag(order) {
      let today = moment();
      let orderStartsAt = moment(order.schedule_event.starts_at);
      let diff = orderStartsAt.diff(today, "minutes");
      if (diff > 2880) {
        TICKET_TAGS.push("Mais de 48h");
      } else if (diff >= 120) {
        TICKET_TAGS.push("Menos de 48h e mais que 2h");
      } else if (diff < 120) {
        TICKET_TAGS.push("Menos de 2h");
      }
    },
    setCustomerTypeTag(order) {
      TICKET_TAGS.push(order.customer_type === "Physical" ? "B2C" : "B2B");
    },
    isABoletoPayment(paymentType) {
      return paymentType === "Boleto";
    },
    isAbsenceTicket() {
      TICKET_TAGS.push("Falta de profissional");
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/freshdeskMixin.js